<template>
	<div>
		<h3>Sélection des traitements</h3>

		<b-form v-on:submit.prevent="onSubmit">
			<b-container fluid>
				<b-row>
					<b-col cols="8"
						><b-form-select
							@change="onSubmit(true)"
							v-model="project"
							:options="projects_options"
							:value="project"
					/></b-col>
				</b-row>
				<b-row>
					<b-col>
						<p>
							<br />
							<b-button
								v-if="if_prev"
								v-on:click="
									page -= 1;
									onSubmit();
								"
								variant="primary"
								><i class="fas fa-arrow-circle-left"></i
							></b-button>
							Page {{ page + 1 }}
							<b-button
								v-if="if_next"
								v-on:click="
									page += 1;
									onSubmit();
								"
								variant="primary"
								><i class="fas fa-arrow-circle-right"></i
							></b-button>
						</p>
					</b-col>
				</b-row>
			</b-container>
		</b-form>

		<br />

		<edit_tabulator :extern_file="false" ref="treats_tabulator"></edit_tabulator>

		<b-button @click="add">Sélectionner</b-button>

		<h3>Traitements sélectionnés</h3>

		<edit_tabulator :extern_file="false" ref="data_tabulator"></edit_tabulator>

		<b-button @click="stats">Actualiser</b-button>

		<h3>Détails</h3>

		<p>Colonnes à afficher</p>

		<b-form-select
			v-model="columns_view"
			:options="columns"
			:select-size="5"
			multiple
			@input="change_columns_view"></b-form-select>
		<br />

		<edit_tabulator :extern_file="false" ref="stats_tabulator"></edit_tabulator>

		<b-button @click="set_timeline">Temps des traitements</b-button>

		<!-- <apexchart v-if="series_timeline" :height="height_timeline" type="rangeBar" :options="options_timeline" :series="[{data: series_timeline}]"></apexchart>-->

		<h3>Moyenne</h3>

		<p>Colonne des moyennes et de l'axe x :</p>

		<b-form-select
			v-model="column_average"
			:options="columns_numbers"
			@input="set_average"></b-form-select>
		<br />

		<p>Colonnes à afficher</p>

		<b-form-select
			v-model="columns_average"
			:options="columns_numbers"
			:select-size="5"
			multiple
			@input="change_columns_average"></b-form-select>
		<br />

		<edit_tabulator :extern_file="false" ref="average_tabulator"></edit_tabulator>

		<h3>Graphique</h3>

		<p>Colonne de l'axe y :</p>

		<b-form-select
			v-model="column_y"
			:options="columns_numbers"
			@input="set_graph"></b-form-select>
		<br />

		<!-- <apexchart v-if="series_avg" height="500" type="line" :options="options_avg" :series="[{name: column_y, data: series_avg}]"></apexchart> -->

	</div>
</template>

<script>
	import edit_tabulator from "../components/edit_tabulator.vue";
	import treatments from "../services/treatments.js";
	import projects from "../services/projects.js";
	import store from "../store";

	import moment, { months } from "moment";

	require('moment/locale/fr')

	var clone = require("clone");

	export default {
		name: "treatments_stats",
		components: {
			edit_tabulator
		},
		data() {
			return {
				page: 0,
				project: null,
				list_projects: [],
				projects_options: [],
				if_prev: true,
				if_next: true,
				treats: [],

				treats_stats: [],
				columns: [],
				columns_view: [],
				columns_numbers: [],
				columns_average: [],
				column_average: "",
				column_y: "",

				height_timeline: 0,
				options_timeline: {},
				series_timeline: null,

				options_avg: {},
				series_avg: null
			};
		},
		methods: {
			onSubmit: async function (reset = false) {
				if (reset)
				{
					this.$refs.data_tabulator.set_data([]);
					this.page = 0;
				}
				if (this.page < 0)
					this.page = 0;
				await this.getTreatments(this.project);
				if (this.page == 0)
					this.if_prev = false;
				else
					this.if_prev = true;
				if (this.treats.length < 100)
					this.if_next = false;
				else
					this.if_next = true;
			},
			changeProject: async function () {},
            isAdmin: function() {
                return store.getters.isAdmin;
			},
			getProjects: async function () {
				try {
					this.list_projects = await projects.getAll(false, true);
				} catch (error) {
					console.log(error);
				}
			},
			change_columns_view()
			{
				this.$refs.stats_tabulator.set_data(this.$refs.stats_tabulator.get_data(), this.columns_view.length > 0 ? this.columns_view : null);
			},
			change_columns_average()
			{
				this.$refs.average_tabulator.set_data(this.$refs.average_tabulator.get_data(), this.columns_average.length > 0 ? this.columns_average : this.columns_number);
			},
			set_graph()
			{
				this.series_avg = null;

				if (!this.column_average || !this.column_average)
					return;

				this.series_avg = [];
				var data_average = this.$refs.average_tabulator.get_data();

				for (var i = 0; i < data_average.length; i++)
				{
					this.series_avg.push({
						x: data_average[i][this.column_average],
						y: data_average[i][this.column_y]
					})
				}

				this.options_avg = {
					chart: {
						height: 500,
						type: 'line'
					},
					stroke: {
						curve: 'smooth'
					},
					xaxis: {
						type: 'numeric',
						title: {
							text: this.column_average
						}
					},
					yaxis: {
						type: 'numeric',
						min: 0,
						title: {
							text: this.column_y
						}
					},
					legend: {
						position: 'top',
						horizontalAlign: 'right',
						floating: true,
						offsetY: -25,
						offsetX: -5
					}
				}
			},
			set_timeline()
			{
				var graph = [];

				for (var i = 0; i < this.treats_stats.length; i++)
				{
					graph.push({
						"label": this.treats_stats[i].uid,
						"start": new Date(this.treats_stats[i]["date première étape"]).getTime(),
						"end": new Date(this.treats_stats[i]["date_end"]).getTime()
					})
				}

				graph.sort(function(a, b) {
					return a["start"] - b["start"];
				});

				this.series_timeline = [];

				for (var i = 0; i < graph.length; i++)
				{
					this.series_timeline.push({
						x: graph[i].label,
						y: [
							graph[i].start,
							graph[i].end
						]
					})
				}

				this.height_timeline = this.series_timeline.length * 50;

				this.options_timeline = {
					chart: {
						height: this.series_timeline.length * 50,
						type: 'rangeBar'
					},
					dataLabels: {
						enabled: true,
						formatter: function(val) {
							var a = moment(val[0])
							var b = moment(val[1])
							var diff = b.diff(a, 'seconds')
							return diff + " s"						}
					},
					plotOptions: {
						bar: {
							horizontal: true
						}
					},
					xaxis: {
						type: 'datetime'
					}
				}

			},
			set_average()
			{
				var self = this;
				var data = this.$refs.stats_tabulator.get_data();

				var obj_data = {};

				if (this.column_average)
				{
					for (var i = 0; i < data.length; i++)
					{
						if (!obj_data[data[i][this.column_average]])
						{
							obj_data[data[i][this.column_average]] = {
								nb: 0,
								lines: []
							}
						}
						obj_data[data[i][this.column_average]].nb++;
						obj_data[data[i][this.column_average]].lines.push(data[i])
					}

					var data = [];
					var keys = Object.keys(obj_data);
					for (var i = 0; i < keys.length; i++)
					{
						var line = {
							nb: obj_data[keys[i]].nb
						};
						var obj_keys = this.columns_numbers;
						for (var j = 0; j < obj_keys.length; j++)
						{
							if (obj_keys[j] != "nb")
							{
								var nb = 0;
								for (var k = 0; k < obj_data[keys[i]].lines.length; k++)
								{
									nb += obj_data[keys[i]].lines[k][obj_keys[j]]
								}
								line[obj_keys[j]] = nb / line.nb;
							}
						}
						data.push(line)
					}
					data.sort(function(a, b) {
						return a[self.column_average] - b[self.columns_average];
					});

				}

				this.$refs.average_tabulator.set_data(data, this.columns_average.length > 0 ? this.columns_average : this.columns_numbers);
			},
			async stats()
			{
				this.treats_stats = [];
				this.columns_numbers = ["nb", "time"];

				var data = this.$refs.data_tabulator.get_data();
				for (var i = 0; i < data.length; i++)
				{
					var treat = {}
					treat.uid = data[i].uid;
					var result = await treatments.get(data[i].uid);
					result = result.treatment;
					treat.uid = data[i].uid;
					treat.date_start = result.dateheure_debut;
					treat.date_end = result.dateheure_fin;
					treat.time = 0;
					if (treat.date_end)
						treat.time = moment(treat["date_end"]).unix() - moment(treat["date_start"]).unix();
					var logs = await treatments.getLogs(data[i].uid);
					for (var j = 0; j < logs.length; j++)
					{
						if (logs[j].niveau == 2)
						{
							treat["date première étape"] = logs[j].dateheure;
							break;
						}
					}
					var meters = result.details.meters;
					if (meters)
					{
						var keys = Object.keys(meters);
						for (var j = 0; j < keys.length; j++)
						{
							if (keys[j] == "time_server")
								meters[keys[j]] = meters[keys[j]] / 1000;
							treat["compteur - synthèse - " + keys[j]] = meters[keys[j]];
							this.columns_numbers.push("compteur - synthèse - " + keys[j]);
						}
					}
					var result = await treatments.getMeters(data[i].uid);
					for (var j = 0; j < result.length; j++)
					{
						if (result[j].libelle == "time_server")
							result[j].compteur = result[j].compteur / 1000;
						treat["compteur - étape " + result[j].etape_uid + " - " + result[j].libelle] = result[j].compteur;
						this.columns_numbers.push("compteur - étape " + result[j].etape_uid + " - " + result[j].libelle);
					}
					this.treats_stats.push(treat);
				}

				this.series_timeline = null;

				this.$refs.stats_tabulator.set_data(this.treats_stats);
				this.$refs.average_tabulator.set_data(this.treats_stats);
				this.set_average();
				this.columns = Object.keys(this.treats_stats[0]);
			},
			add()
			{
				var data = this.$refs.data_tabulator.get_data();
				if (data.length > 0 && Object.keys(data[0]).length > 0)
					data = data.concat(this.$refs.treats_tabulator.get_data());
				else
					data = this.$refs.treats_tabulator.get_data();
				this.$refs.data_tabulator.set_data(data);
				this.stats();
			},
			getTreatments: async function (id_project) {
				try {
					this.treats = [];
					var treats = await treatments.getAll(id_project, this.page, 100);
					var projects = treats["projects"];
					var users = {};
					for (var i = 0; i < treats["users"].length; i++) {
						users[treats["users"][i]["uid"]] = treats["users"][i];
					}
					for (var i = 0; i < projects.length; i++) {
						if (projects[i]["traitements"]) {
							for (
								var j = 0;
								j < projects[i]["traitements"].length;
								j++
							) {
								var treat = {
									libelle: projects[i]["libelle"],
									date_start: projects[i]["traitements"][j][
										"dateheure_debut"
									],
									date_end:
										projects[i]["traitements"][j][
											"dateheure_fin"
										],
									uid: projects[i]["traitements"][j]["uid"],
								}

								/*
									user: users[
										projects[i]["traitements"][j][
											"client_user_uid"
										]
									],
								*/

								if (projects[i]["traitements"][j].resultat == "ko")
            						treat._cellVariants = {
										libelle: 'danger',
										date: 'danger',
										date_end: 'danger',
										user: 'danger',
										link: 'danger'
									};

								this.treats.push(treat);
							}
						}
					}
					this.$refs.treats_tabulator.set_data(this.treats);
				} catch (error) {
					console.log(error);
				}
			}
		},
		created: async function () {

			if (store.state.user.rules && !store.state.user.rules.treatments_stats) {
				this.$router.push({ name: "profile" });
			}

			await this.getProjects();
			for (var i = 0; i < this.list_projects.length; i++) {
				if (this.list_projects[i].details && this.list_projects[i].details.test == true)
				{
					this.project = this.list_projects[i]["uid"];
				}
				this.projects_options.push({
					value: this.list_projects[i]["uid"],
					text: this.list_projects[i]["libelle"],
				});
			}

			if (!this.project)
				this.project = this.projects_options[0].value;

			await this.getTreatments(this.project);
		},
	};
</script>

<style>
	.rowClass {
		background-color: pink;
	}
</style>
